var _path;
const _excluded = ["svgRef", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgUploadIcon = _ref => {
  let {
      svgRef,
      title
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 23,
    viewBox: "0 0 35 23",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.5873 9.68215C28.5873 9.59074 28.6027 9.49934 28.6027 9.40793C28.6027 4.45676 24.6205 0.450119 19.7082 0.450119C16.1643 0.450119 13.12 2.53723 11.6902 5.55363C11.0675 5.24133 10.3679 5.05852 9.62992 5.05852C7.36211 5.05852 5.47098 6.72668 5.10967 8.9052C2.3883 9.83449 0.443359 12.4167 0.443359 15.456C0.443359 19.2798 3.52605 22.3876 7.32367 22.3876H15.2034V16.2939H11.498L17.6634 9.91828L23.8287 16.2863H20.1234V22.38H28.6027C32.0774 22.38 34.8834 19.5236 34.8834 16.0273C34.8834 12.531 32.062 9.68977 28.5873 9.68215Z",
    fill: "#7F7F7F"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgUploadIcon, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/upload_icon.30f976ed.svg";
export { ForwardRef as ReactComponent };